export default "__VITE_ASSET__qA21PSGk__"